import {defineStore} from "pinia";
import modules from "../../constants/modules";

const customCompare = (a,b) => {
  const orderOfTitles = [
    modules.general.title,
    modules.satVault.title,
    modules.manualLoad.title,
    modules.incomeAndExpenditure.title,
    modules.payroll.title,
    modules.blackList.title,
    modules.analytics.title,
    modules.billing.title,
    modules.chatGPT.title,
    modules.sanfer.title
  ];
  const titleA = a.title;
  const titleB = b.title;
  return orderOfTitles.indexOf(titleA) - orderOfTitles.indexOf(titleB);
}

export const permissionsUserStore = defineStore('permissions', {
  state: () => ({
    optionsUser: null,
    isAdmin: false,
    roleType: '',
    roleCodeName: '',
    permissions: null,
  }),
  getters: {
    getOptionsUser: (state) => state.optionsUser,
    getIsAdmin: (state) => state.isAdmin,
    getRoleType: (state) => state.roleType,
    getRoleCodeName: (state) => state.roleCodeName,
    getPermissions: (state) => state.permissions,
    getDrawerPaths: (state) => {
      if (!state.optionsUser) return [];
      return Object.entries(modules)
        .filter(([moduleKey]) => state.optionsUser[moduleKey])
        .map(([moduleKey, moduleInfo]) => {
          const items = moduleInfo.items.filter(item =>
            state.optionsUser[moduleKey].some(permission => permission.code === item.code)
          );
          return { title: moduleInfo.title, icon: moduleInfo.icon ,items };
        })
        .filter(({ items }) => items.length > 0)
        .sort(customCompare);
    }
  },
  actions: {
    setPermissions(payload){
      this.permissions = payload;
    },
    setRoleType(payload){
      this.roleType = payload;
    },
    setCodeTypeRole(payload){
      this.roleCodeName = payload;
    },
    setIsAdmin(payload){
      this.isAdmin = payload;
    },
    setOptionsUser(payload){
      this.optionsUser = payload;
    }
  },
  persist: {
    storage: sessionStorage,
  },
});
